import { Cookies } from 'react-cookie'
import { FITBIT_RECONNECT_DISMISSED_COOKIE } from 'components/common/Constants'

// Cookies that hold a choice for one session only, such as a warning that the
// user hid. A logout drops them, so the next login starts with a clean slate.
export const SESSION_SCOPED_COOKIES = [FITBIT_RECONNECT_DISMISSED_COOKIE]

export const clearSessionScopedCookies = (cookies: Cookies = new Cookies()): void => {
  SESSION_SCOPED_COOKIES.forEach(name => cookies.remove(name, { path: '/' }))
}
